module.exports = __webpack_public_path__ + "media/images/common/services/talkport/ogp-0206abf5920c3953153bb56cc026dec5.png";